module.exports = __webpack_public_path__ + "img/rightArrowB.c0b1e320.svg";